(function () {
  'use strict';

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function initBuy(box) {
    var variants = [];
    var jsonEl = box.querySelector('[data-variants]');
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = box.querySelector('form');
    var idInput = box.querySelector('[data-variant-id]');
    var priceEl = box.querySelector('[data-price]');
    var compareEl = box.querySelector('[data-compare]');
    var addBtn = box.querySelector('[data-add]');
    var addLabel = box.querySelector('[data-add-label]');
    var errorEl = box.querySelector('[data-error]');
    var currency = box.getAttribute('data-currency');
    var locale = box.getAttribute('data-locale');
    var direct = box.getAttribute('data-direct') === 'true';

    function selectedOptions() {
      var out = [];
      box.querySelectorAll('.opt').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out[parseInt(fs.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return out;
    }

    function update() {
      if (!box.querySelector('.opt')) return;
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] === o; });
      });
      if (!match) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      priceEl.textContent = money(match.price, currency, locale);
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = money(match.compare_at_price, currency, locale);
        compareEl.hidden = false;
      } else if (compareEl) {
        compareEl.hidden = true;
      }
      addBtn.disabled = !match.available;
      addLabel.textContent = match.available ? 'Checkout securely' : 'Sold out';
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    box.addEventListener('change', update);

    var qty = box.querySelector('[data-qty] input');
    var minus = box.querySelector('[data-qty-minus]');
    var plus = box.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = Math.min(20, (parseInt(qty.value, 10) || 1) + 1); });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // falls back to a normal form post to the cart
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.disabled = true;
      var original = addLabel.textContent;
      addLabel.textContent = 'Opening secure checkout';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () { window.location.assign(direct ? '/checkout' : '/cart'); })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          addBtn.disabled = false;
          addLabel.textContent = original;
        });
    });

    update();
  }

  document.querySelectorAll('[data-buy]').forEach(initBuy);

  // product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); }
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  // sticky mobile bar
  var sticky = document.querySelector('[data-sticky]');
  if (sticky) {
    var offer = document.getElementById('offer');
    var onScroll = function () {
      var past = window.scrollY > 700;
      var inOffer = false;
      if (offer) {
        var r = offer.getBoundingClientRect();
        inOffer = r.top < window.innerHeight && r.bottom > 0;
      }
      sticky.hidden = !(past && !inOffer);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
